export const MAX_MOBILE_DPR = 2;

/** Pure clamp, exported for tests. Guards non-finite and non-positive input. */
export function clampedDpr(raw: number): number {
  if (!Number.isFinite(raw) || raw <= 0) return 1;
  return Math.min(raw, MAX_MOBILE_DPR);
}

/**
 * Cap window.devicePixelRatio for the mobile shell's lifetime.
 *
 * Canvas renderers across the app sample devicePixelRatio at draw time, so
 * clamping it here reaches every chart without editing each renderer. On a 3x
 * phone the GEX profile and candle canvases would otherwise allocate 9x the
 * pixels. Returns a restorer that reinstates the original descriptor.
 */
export function installDprClamp(): () => void {
  if (typeof window === 'undefined') return () => undefined;

  const original = Object.getOwnPropertyDescriptor(window, 'devicePixelRatio');
  // Read once: the getter below must not read the property it replaces.
  const raw = window.devicePixelRatio;

  Object.defineProperty(window, 'devicePixelRatio', {
    configurable: true,
    get: () => clampedDpr(raw),
  });

  return () => {
    if (original) {
      Object.defineProperty(window, 'devicePixelRatio', original);
    } else {
      delete (window as unknown as Record<string, unknown>).devicePixelRatio;
    }
  };
}
